<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper screenFlashNotification" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="screenFlashNotificationWindow clickable fadeIn" @click="onModalClose(close)" ng-class="{fadeIn: fadeIn, fadeOut: fadeOut}">
				<div class="backgroundFlare rotate">
					<div class="flareRay" v-for="n in (1, 12)"></div>
				</div>
				<div ng-if="::windowParams.notificationType" class="screenNotificationContent achievement" src="::'tpl/screenFlashNotification/types/'+windowParams.notificationType+'.html'">
					<div class="achievement_notification_huge_illu"></div>
					<div class="achievementInfoArea">
						<div class="middleArea">
							<div class="captionEnding endingFrom achievement_captionFrom_layout"></div>
							<div class="captionEnding endingTo achievement_captionTo_layout"></div>
							<div class="achievementInfo">
								<span><span>ПОЛУЧЕНО ДОСТИЖЕНИЕ!</span></span>
								<div class="achievementInfoReward">
									<span>
										<b><span>Теперь порядок!</span></b>
										<span>&nbsp;</span>
										<b>+1</b>
										<span>&nbsp;</span>
										<i class="feature_prestige_small_flat_white"></i>
									</span>
								</div>
							</div>
						</div>
					</div>
					<div class="achievementIconWrapper">
						<i class="achievements_frame1_huge_illu achievementFrame"></i>
						<i ng-if="windowParams.level > 0 || windowParams.special" class="achievements_type26_large_illu achievementIcon"></i>
					</div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>